<template>
    <Panel title="Solicitudes para unirse" icon="envelope" v-if="solicitudes.length > 0">
        <div class="panel-block" v-for="solicitud in solicitudes" :key="solicitud.id">
            <article class="media usuario-solicitud">
                <figure class="media-left" :title="solicitud.usuario.name">
                    <p class="image is-32x32"><img :src="solicitud.usuario.image" alt="" class="is-rounded"></p>
                </figure>
				<div class="media-content">
                    <div class="content truncate">{{ nombreUsuario(solicitud.usuario.name) }}</div>
				</div>
                <div class="media-right">
                    <div class="buttons">
                        <button class="button is-success is-small" @click.prevent="aceptar(solicitud)"><span class="icon"><font-awesome-icon icon="check"/></span><span class="is-hidden-tablet-only is-hidden-desktop-only">Aceptar</span></button>
                        <button class="button is-small" @click.prevent="rechazar(solicitud)"><span class="icon"><font-awesome-icon icon="times-circle"/></span><span class="is-hidden-tablet-only is-hidden-desktop-only">Rechazar</span></button>
                    </div>
                </div>
			</article>
        </div>
    </Panel>
</template>

<script>
    import Panel from '@/components/Panel'
    export default {
        props:{
            solicitudes: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },
        components: {Panel},
        name: 'Solicitudes',
        methods: {
            aceptar(solicitud){
                this.$emit('aceptar',solicitud)
            },
            rechazar(solicitud){
                this.$emit('rechazar',solicitud)
            },
            nombreUsuario(nombre){
                if (nombre.length > 12) {
                    return nombre.substring(0,12) + '...'
                } 
                return nombre
            }
        },
    }
</script>

<style lang="css" scoped>
.usuario-solicitud{
    flex-grow: 1;
}
.media-content{
    overflow-x: auto;
}
</style>